import { Box, Button, styled } from "@mui/material";
import useFeatureFlag from "hooks/useFeatureFlag";
import PersistDismissalFunctionality from "./helpers/PersistDismissalFunctionality";
import Close from "@mui/icons-material/Close";

type ImageAccouncementBannerProps = {
  imageUrl: string;
  featureFlagName: string;
  timesToDisappear?: number;
  hideCloseButton?: boolean;
  showUntil?: Date;
  redirectTo?: string;
};

const CustomCloseButton = styled(Button)({
  position: "absolute",
  color: "white",
  minWidth: "25px",
  width: "25px",
  height: "25px",
  border: "none",
  padding: 0,
  margin: 0,
  float: "right",
});

export default function ImageAccouncementBanner({
  imageUrl,
  featureFlagName,
  timesToDisappear = 1,
  hideCloseButton = false,
  showUntil = undefined,
  redirectTo = undefined,
}: ImageAccouncementBannerProps) {
  const { enabled: enabledFeature } = useFeatureFlag(featureFlagName);
  const { showComponent, dismissComponent } = PersistDismissalFunctionality({
    cookiesKey: `${featureFlagName} Banner`,
    timesToDisappear,
  });

  const BannerImage = styled("img")({
    width: "100%",
    cursor: redirectTo ? "pointer" : "default",
  });

  if (!enabledFeature) return null;

  if (!showComponent) return null;

  if (showUntil && new Date() > showUntil) return null;

  const handleImageClick = () => {
    if (redirectTo) {
      window.open(redirectTo, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box sx={{ display: "inline-block", width: "100%" }}>
      {hideCloseButton ? null : (
        <CustomCloseButton onClick={dismissComponent}>
          <Close />
        </CustomCloseButton>
      )}
      <BannerImage
        src={imageUrl}
        alt="Image Announcement Banner"
        style={{ width: "100%" }}
        onClick={handleImageClick}
      />
    </Box>
  );
}
